export default "__VITE_ASSET__BL6ZFAmK__"